<template>
  <b-card>
    <checklist-honorarios-list
      :carregar="carregar"
      :novo="novo"
      :editar="editar"
      :remover="remover"
      :colunas="colunasListagem"
      :info="info"
      :mostar-copia="true"
      :copiar="copiar"
      :filtros="filtros"
      class="checklist-honorarios"
    >
      <template
        slot="celula-personalizada"
        slot-scope="{props}"
      >
        <span v-if="props.column.field === 'atividadesNome'">
          <div
            v-for="(atividade, $index) in props.row.atividadesNome"
            :key="$index"
            class="d-inline-flex"
          >
            <span
              class="badge badge-secondary atividade-badge"
            >{{ atividade }}</span>
          </div>
        </span>
        <span v-if="props.column.field === 'somenteFilial'">
          {{ props.row.somenteFilial? 'Sim' : 'Não' }}
        </span>
        <span v-if="props.column.field === 'tipoProposta'">
          {{ props.row.tipoProposta == 'transferencia'? 'Transferência' : props.row.tipoProposta == 'constituicao' ? 'Constituição' : '' }}
        </span>
      </template>
    </checklist-honorarios-list>
  </b-card>
</template>

<style lang="scss">
.atividade-badge {
  margin-right: 0.3rem;
  background-color: transparent;
  border: 1px solid #82868b !important;
  color: #82868b;
  height: 1.5rem;
  font-size: 12px;
  font-weight: 700;
}

.checklist-honorarios {
  .th-acao {
    width: 10.5rem !important;
  }
}
</style>

<script>
import api from '@/app-modulo/comercial/parametrizacao-checklist-honorarios/shared/services/api'

export default {
  name: 'ChecklistHonorariosVisualizacao',
  components: {
    checklistHonorariosList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
  },
  data() {
    return {
      colunasListagem: [
        { label: 'Nome', field: 'nome', editable: true },
        { label: 'Tipo checklist', field: 'tipoProposta', type: 'personalizada' },
        { label: 'Filial', field: 'somenteFilial', type: 'personalizada' },
        { label: 'Tipo de tributação', field: 'tributacaoNome' },
        { label: 'Tipos de Atividades', field: 'atividadesNome', type: 'personalizada' },
      ],
      filtros: [{ colunas: ['Nome', 'SomenteFilial', 'TipoChecklist', 'TributacaoNome', 'AtividadesNome'], valor: null }],
      info: [
        { label: 'Data de cadastro: ', campo: 'dataCadastro' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
    }
  },
  methods: {
    carregar(page, pageSize, filtros) {
      return api.getChecklistHonorarios(page, pageSize, filtros)
    },
    novo() {
      this.$router.push({ name: 'novo-checklist-honorarios' })
    },
    editar(value) {
      this.$router.push({ name: 'editar-checklist-honorarios', params: { id: value.id } })
    },
    copiar(value) {
      this.$router.push({ name: 'copiar-checklist-honorarios', params: { copia: true, id: value.id } })
    },
    remover(itens) {
      const itensInner = itens
      return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-plusplus
        for (let i = 0; i < itensInner.length; i++) {
          const item = itensInner[i]
          api.deleteParametrizacaoChecklistHonorarios(item.id)
            .then(() => {
              resolve()
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
  },
}
</script>
